<div class="main-nav-business-desktop">
  <div class="main-nav-business-desktop-container container">
    <div class="main-nav-business-desktop-content">
      <a
        class="main-nav-business-desktop-logo"
        [routerLink]="items.businessPageRootLink">
        <img
          src="/assets/images/logo/logo-smarthead-business-turquoise.svg"
          title="SmartHead"
          [ngClass]="{ bigger: bigger }" />
      </a>

      <div
        class="main-nav-business-desktop-items"
        data-cy="main-nav-menu-items">
        <sh-main-nav-single-item [item]="items.plansItem"></sh-main-nav-single-item>

        <a
          href="https://docs.besmarthead.com/getting-started/introduction"
          target="_blank"
          >{{ 'header.resources' | transloco }}</a
        >

        <sh-main-nav-single-item
          data-cy="main-nav-business-desktop-blog"
          [item]="items.mediaItem"></sh-main-nav-single-item>

        <sh-main-nav-about-us></sh-main-nav-about-us>

        @if ((nav.hasProfile$ | async) === true) {
          <sh-main-nav-profiles-desktop [profiles]="(nav.profileWhereUserAdmin$ | async) ?? []"></sh-main-nav-profiles-desktop>
        } @else {
          <sh-main-nav-request-demo></sh-main-nav-request-demo>
        }

        @if (nav.loggedUser$ | async; as loggedUser) {
          <sh-main-nav-user [loggedUser]="loggedUser"> </sh-main-nav-user>
        } @else {
          <sh-main-nav-languages></sh-main-nav-languages>
        }

        <div class="d-flex menu-item">
          <a
            class="font-weight-bold w-100"
            [attr.title]="'header.explore-activities' | transloco"
            [routerLink]="items.newsfeedItem.link">
            <button
              class="new-sh-button w-100"
              color="accent"
              mat-stroked-button>
              {{ 'header.explore-activities' | transloco }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
